// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as ReactIntl from "react-intl";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as MinorUnitsJs from "./minorUnits.js";
import * as JsxRuntime from "react/jsx-runtime";
import FormattedCurrencyModuleCss from "./FormattedCurrency.module.css";

let classes = FormattedCurrencyModuleCss;

let context = React.createContext("CZK");

let minorUnits = MinorUnitsJs.minorUnits;

function getMinorUnit(currency) {
  return Stdlib_Option.getOr(minorUnits[currency], 100.0);
}

function useCurrency() {
  let currency = React.useContext(context);
  let minorUnit = getMinorUnit(currency);
  return {
    currency: currency,
    minorUnit: minorUnit
  };
}

function FormattedCurrency(props) {
  let value = props.value;
  let match = useCurrency();
  return <ReactIntl.FormattedNumber
    value={value / match.minorUnit}
    style={"currency"}
    currency={match.currency}
  >
    {Stdlib_Option.map(props.format, fn => fn(value))}
  </ReactIntl.FormattedNumber>;
}

let make = context.Provider;

let Provider = {
  make: make
};

function formatAccounting(value) {
  return formattedNumber => {
    let negative = value < 0;
    return React.cloneElement(<span />, {
      className: classes.accounting,
      children: formattedNumber,
      "data-negative": Pervasives.string_of_bool(negative)
    });
  };
}

let make$1 = FormattedCurrency;

export {
  classes,
  context,
  minorUnits,
  getMinorUnit,
  useCurrency,
  make$1 as make,
  Provider,
  formatAccounting,
}
/* classes Not a pure module */
